import { render } from "./Ticket.vue?vue&type=template&id=02ca718c"
import script from "./Ticket.vue?vue&type=script&lang=js"
export * from "./Ticket.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__